<div class="row divider-top mt-5 pt-5" id="top">
    <div class="col-4 offset-2 left" id="top-left"></div>
    <div class="col-4 right" id="top-right"></div>
</div>
<div class="row divider-bottom" id="bottom">
    <div class="col-4 offset-2 left" id="bottom-left"></div>
    <div class="col-4 right" id="bottom-right"></div>
</div>
<h2 class="text-center text-uppercase mt-5">{{ content }}</h2>
